import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { TagManagerService } from "../../../core/services/tag-manager.service";

@Component({
    selector: 'career-grid-display',
    templateUrl: './career-grid-display.component.html',
    styleUrls: ['./career-grid-display.component.scss'],
    standalone: false
})
export class CareerGridDisplayComponent {

    @Input() blocks$: Observable<any>;
    @Output("openModal") openModal: EventEmitter<any> = new EventEmitter();

    constructor(                
        private gtm: TagManagerService,
        private modalService: NgbModal
    ) { }

    public triggerModal(data, title, dateType) {
        //ga log event
        this.openModal.emit({data, title, dateType})
        //this.gtm.gaLinkClicked(gaCategory, title);
        //this.jobs = jobs;
        //this.modalTitle = title;
        //this.dateType = dateType;
        //this.modalService.open(content, { size: 'lg' });
    }

}
